import { render } from "./ButtonControl.vue?vue&type=template&id=5b32bc94&scoped=true"
import script from "./ButtonControl.vue?vue&type=script&lang=js"
export * from "./ButtonControl.vue?vue&type=script&lang=js"

import "./ButtonControl.vue?vue&type=style&index=0&id=5b32bc94&scoped=true&lang=css"

import exportComponent from "C:\\Deployment\\Member Portal\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5b32bc94"]])

export default __exports__